export default __webpack_public_path__ + "static/media/bush.d6619e38.png";